import { ReactComponent as InformationIconSVG } from '@/assets/icons/InformationIcon.svg';
import { SVGProps } from 'react';

const InformationIcon = (props: SVGProps<SVGSVGElement>) => <InformationIconSVG {...props} />;

export default InformationIcon;
